import { render, staticRenderFns } from "./addOrg.vue?vue&type=template&id=b7e2d1d4&scoped=true&"
import script from "./addOrg.vue?vue&type=script&lang=js&"
export * from "./addOrg.vue?vue&type=script&lang=js&"
import style0 from "./addOrg.vue?vue&type=style&index=0&id=b7e2d1d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e2d1d4",
  null
  
)

export default component.exports